import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AirportService } from '../../airport/airport.service';
import { TagService } from '../services/tag.service';
var EditTagsComponent = /** @class */ (function () {
    function EditTagsComponent(_matDialogRef, data, _airportService, _tagService) {
        this._matDialogRef = _matDialogRef;
        this._airportService = _airportService;
        this._tagService = _tagService;
        this.disableClose = false;
        this.tags = [];
        this.tagsGroup = [];
        this.title = '';
        this.except = null;
        this.isLoading = true;
        this.business = data.business;
        this.tagsGroup = data.tagsGroup;
        this.title = data.title;
        if (data.except) {
            this.except = data.except;
        }
    }
    EditTagsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        _a.allTags = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _c.sent();
                        this.handleError();
                        return [3 /*break*/, 3];
                    case 3:
                        if (!this.business.airportId) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.business.identifier.toString())];
                    case 4:
                        _b.business = _c.sent();
                        _c.label = 5;
                    case 5:
                        this.isLoading = false;
                        this.parseTagNames();
                        this._matDialogRef.backdropClick().subscribe(function () {
                            _this._matDialogRef.close(true);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /* tagGroup: String[] -> If a tag matches an element in tagGroup we keep it.
          -> Eg. tagGroup = ['Amenities::']
          -> All tags that match 'Amentities::' will be pushed to tags array
       except: String[]  -> If a tag matches an element in except then it will be excluded.
          -> Eg. except = ['Amenities::Internet::']
          -> Any tag with 'Amentities::Internet::' will be excluded from the tags array
    The method will check the tags in tagGroup and match them against all the tags. If any tag
    matches an element in tagsGroup then it will be added into the final result unless its in except. */
    EditTagsComponent.prototype.parseTagNames = function () {
        if (this.tagsGroup.length > 0) {
            var _loop_1 = function (aTag) {
                var tagName = aTag.tagName;
                if (!tagName.includes('::') || (this_1.tagsGroup.every(function (tag) { return !tagName.includes(tag); }))) {
                    return "continue";
                }
                else if (this_1.except && this_1.except.length > 0 && this_1.except.some(function (tagToExclude) { return tagName.includes(tagToExclude); })) {
                    return "continue";
                }
                else {
                    // The length check is on the off chance that something like Maintenance::Airframe::Manufacturers:: exists in tags
                    if (this_1.tagsGroup.some(function (tag) { return tagName.includes(tag) && tagName.length !== tag.length; })) {
                        this_1.tags.push(aTag);
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.allTags; _i < _a.length; _i++) {
                var aTag = _a[_i];
                _loop_1(aTag);
            }
        }
    };
    EditTagsComponent.prototype.checkBoxChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, _a, _b, _c, e_2;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.disableClose = true;
                        this._matDialogRef.disableClose = true;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        id = void 0;
                        id = this.business.id || this.business.airportId;
                        if (!this.business.id) return [3 /*break*/, 3];
                        _b = (_a = Object).assign;
                        _c = [this.business];
                        return [4 /*yield*/, this._airportService.getBusiness(id.toString())];
                    case 2:
                        _b.apply(_a, _c.concat([_d.sent()]));
                        _d.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _d.sent();
                        this.handleError();
                        return [3 /*break*/, 5];
                    case 5:
                        this.disableClose = false;
                        this._matDialogRef.disableClose = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditTagsComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.business) {
                    this._matDialogRef.close(true);
                }
                return [2 /*return*/];
            });
        });
    };
    EditTagsComponent.prototype.handleError = function () {
        this._matDialogRef.close(false);
    };
    return EditTagsComponent;
}());
export { EditTagsComponent };
